import { Map } from 'immutable';

import {
  GET_MEDICAL_CERTIFICATE_REQUEST,
  GET_MEDICAL_CERTIFICATE_FAILURE,
  GET_MEDICAL_CERTIFICATE_SUCCESS,
} from './action';

const initialState = Map({
  type: '',
  payload: Map({}),
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === GET_MEDICAL_CERTIFICATE_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], Map({}));
  }

  if (type === GET_MEDICAL_CERTIFICATE_FAILURE) {
    const { payload } = action;
    return state.updateIn(['type'], () => type).setIn(['payload'], Map(payload));
  }

  if (type === GET_MEDICAL_CERTIFICATE_SUCCESS) {
    const { payload } = action;
    return state.updateIn(['type'], () => type).setIn(['payload'], Map(payload));
  }

  return state;
}

export default reducer;
